/* eslint-disable-next-line sort-imports */
import React from "react";
/* eslint-disable-next-line sort-imports */
import { Page } from "@lighting-beetle/lighter-styleguide";

import AccessibilityDocs from "../docs/accessibility.mdx";
import BarDocs from "../components/Bar/Bar.mdx";
import ButtonDocs from "../components/Button/docs/Button.mdx";
import ButtonGroupDocs from "../components/Button/docs/ButtonGroup.mdx";
import ButtonLayoutDocs from "../components/Button/docs/ButtonLayout.mdx";
import CardDocs from "../components/Card/Card.mdx";
import ColorsDocs from "../docs/color.mdx";
import ComponentTemplateDocs from "../docs/component-template.mdx";
import DropdownDocs from "../components/Dropdown/Dropdown.mdx";
import Fieldset from "../components/Forms/Fieldset/Fieldset.mdx";
import FlexAlignmentUtilsDocs from "../docs/utils.flexalignment.mdx";
import FormGridDocs from "../components/Forms/FormGrid/FormGrid.mdx";
import GridDocs from "../components/Grid/Grid.mdx";
import HowToCreateSpace from "../docs/how-to-create-space.mdx";
import IconDocs from "../components/Icon/Icon.mdx";
import ImageDocs from "../components/Image/Image.mdx";
import InputDocs from "../components/Forms/Input/Input.mdx";
import ListDocs from "../components/List/List.mdx";
import MessageDocs from "../components/Forms/Message/Message.mdx";
import ModalDocs from "../components/Modal/Modal.mdx";
import ProductCardPatternDocs from "../patterns/LearnAndDecide/ProductCard/ProductCard.mdx";
import RadioCheckDocs from "../components/Forms/RadioCheck/RadioCheck.mdx";
import SelectDocs from "../components/Forms/Select/Select.mdx";
import SpacingUtilsDocs from "../docs/utils.spacing.mdx";
import TableDocs from "../components/Table/Table.mdx";
import TabsDocs from "../components/Tabs/Tabs.mdx";
import ToggleDocs from "../docs/toggle.mdx";
import TooltipDocs from "../components/Tooltip/Tooltip.mdx";
import TypographyListDocs from "../components/Typography/docs/Lists.mdx";
import TypographyTextDocs from "../components/Typography/docs/Text.mdx";
import TypographyUtilitiesDocs from "../components/Typography/docs/Utilities.mdx";
import VisbilityUtilsDocs from "../docs/utils.visibility.mdx";

export default [
  {
    title: "Introduction",
    path: "/",
    render: <h1>Hello!</h1>,
  },
  {
    title: "Getting started",
    path: "/getting-started",
    nodes: [
      {
        title: "Component template",
        path: "/component-template",
        render: <Page render={ComponentTemplateDocs} />,
      },
      {
        title: "How to create space",
        path: "/how-to-create-space",
        render: <Page render={HowToCreateSpace} />,
      },
      {
        title: "Accessibility",
        path: "/accessibility",
        render: <Page render={AccessibilityDocs} />,
      },
    ],
  },
  {
    title: "Foundation",
    path: "/foundation",
    nodes: [
      {
        title: "Color palette",
        path: "/color-palette",
        render: <Page render={ColorsDocs} />,
      },
      {
        title: "Typography",
        path: "/typography",
        nodes: [
          {
            title: "Base",
            path: "/base",
            render: <Page render={TypographyTextDocs} />,
          },
          {
            title: "Lists",
            path: "/lists",
            render: <Page render={TypographyListDocs} />,
          },
          {
            title: "Utilities",
            path: "/utilities",
            render: <Page render={TypographyUtilitiesDocs} />,
          },
        ],
      },
    ],
  },
  {
    title: "Components",
    path: "/components",
    nodes: [
      {
        title: "Bar",
        path: "/bar",
        render: <Page render={BarDocs} />,
      },
      {
        title: "Button",
        path: "/button",
        nodes: [
          {
            title: "Base",
            path: "/base",
            render: <Page render={ButtonDocs} />,
          },
          {
            title: "Layout",
            path: "/layout",
            render: <Page render={ButtonLayoutDocs} />,
          },
          {
            title: "Group",
            path: "/group",
            render: <Page render={ButtonGroupDocs} />,
          },
        ],
      },
      {
        title: "Card",
        path: "/card",
        render: <Page render={CardDocs} />,
      },
      {
        title: "Dropdown",
        path: "/dropdown",
        render: <Page render={DropdownDocs} />,
      },
      {
        title: "Forms",
        path: "/forms",
        nodes: [
          {
            title: "Input",
            path: "/input",
            render: <Page render={InputDocs} />,
          },
          {
            title: "Radio/Checkbox",
            path: "/radio-checkbox",
            render: <Page render={RadioCheckDocs} />,
          },
          {
            title: "Select",
            path: "/select",
            render: <Page render={SelectDocs} />,
          },
          {
            title: "Layout",
            path: "/layout",
            render: <Page render={FormGridDocs} />,
          },
          {
            title: "Fieldset",
            path: "/fieldset",
            render: <Page render={Fieldset} />,
          },
          {
            title: "Messages",
            path: "/messages",
            render: <Page render={MessageDocs} />,
          },
        ],
      },
      {
        title: "Grid",
        path: "/grid",
        render: <Page render={GridDocs} />,
      },
      {
        title: "Icons",
        path: "/icons",
        render: <Page render={IconDocs} />,
      },
      {
        title: "Image",
        path: "/image",
        render: <Page render={ImageDocs} />,
      },
      {
        title: "List",
        path: "/list",
        render: <Page render={ListDocs} />,
      },
      {
        title: "Modal",
        path: "/modal",
        render: <Page render={ModalDocs} />,
      },
      {
        title: "Table",
        path: "/table",
        render: <Page render={TableDocs} />,
      },
      {
        title: "Tabs",
        path: "/tabs",
        render: <Page render={TabsDocs} />,
      },
      {
        title: "Tooltip",
        path: "/tooltip",
        render: <Page render={TooltipDocs} />,
      },
    ],
  },
  {
    title: "Utilities",
    path: "/utilities",
    nodes: [
      {
        title: "Flex alignment",
        path: "/flex-alignment",
        render: <Page render={FlexAlignmentUtilsDocs} />,
      },
      {
        title: "Spacing",
        path: "/spacing",
        render: <Page render={SpacingUtilsDocs} />,
      },
      {
        title: "Visibility",
        path: "/visibility",
        render: <Page render={VisbilityUtilsDocs} />,
      },
      {
        title: "Typography",
        path: "/typography",
        render: <Page render={TypographyUtilitiesDocs} />,
      },
    ],
  },
  {
    title: "JS Modules",
    path: "/js-modules",
    nodes: [
      {
        title: "Toggle",
        path: "/toggle",
        render: <Page render={ToggleDocs} />,
      },
    ],
  },
  {
    title: "Patterns",
    path: "/patterns",
    nodes: [
      {
        title: "Learn & Decide",
        path: "/learn-and-decide",
        nodes: [
          {
            title: "Product Card",
            path: "/product-card",
            render: <Page render={ProductCardPatternDocs} />,
          },
        ],
      },
    ],
  },
];
